// @ts-check
import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@material-ui/core';
import { priceFormatterWithCommas } from 'utils';

const ProductPrice = ({ classes, retailPrice, originalPrice, adjustedPrice, currencyCode }) => {
  const formattedRetailPrice = priceFormatterWithCommas(retailPrice);

  if (adjustedPrice) {
    return (
      <div className={classes.adjusted}>
        <Typography data-testid="adjusted-price">
          {currencyCode}
          {priceFormatterWithCommas(adjustedPrice)}
        </Typography>
        <Typography className={classes.crossedOut} data-testid="retail-price">
          {currencyCode}
          {formattedRetailPrice}
        </Typography>
      </div>
    );
  }

  if (originalPrice && !retailPrice === originalPrice) {
    return (
      <>
        <Typography display="inline" className={classes.crossedOut} data-testid="original-price">
          {currencyCode}
          {priceFormatterWithCommas(originalPrice)}
        </Typography>
        <Typography display="inline" data-testid="retail-price">
          {currencyCode}
          {formattedRetailPrice}
        </Typography>
      </>
    );
  }

  return (
    <Typography data-testid="retail-price">
      {currencyCode}
      {formattedRetailPrice}
    </Typography>
  );
};

ProductPrice.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string),
  retailPrice: PropTypes.string,
  originalPrice: PropTypes.string,
  adjustedPrice: PropTypes.string,
  currencyCode: PropTypes.string,
};

ProductPrice.defaultProps = {
  currencyCode: '$',
  classes: {},
};

export default ProductPrice;
